module.exports = __webpack_public_path__ + "static/003.thumb-b869479dcf10451a65449fb390cd86c1.jpg";